

import useMenuStore from '@/store/modules/menu'
import useSettingsStore from '@/store/modules/settings'
import { useI18n } from 'vue-i18n'
import { titleKeyMap, titleenKeyMap } from '@/store/modules/titleKeyMap'
export default function useMenu() {
  const router = useRouter()
  const { t, te } = useI18n()

  const settingsStore = useSettingsStore()
  const menuStore = useMenuStore()
  function initTabbarI18n(list: any) {
    const currentLanguage = localStorage.getItem('app_language') || 'zh-cn';
  
    if (list.length) {
      list.forEach((item: { title: string }) => {
        if (!item.title || typeof item.title !== 'string') {
          return; // 如果标题不存在或不是字符串，跳过处理
        }
  
        if (currentLanguage == 'en') {
          // console.log(currentLanguage, '英文', '当前标题:', item.title);
          // 英文环境下，检查标题是否已经是英文
          // 如果标题包含中文字符，则需要翻译成英文
          if (/[\u4e00-\u9fa5]/.test(item.title)) {
            // 使用反向映射表查找对应的英文标题
            const enTitle = titleKeyMap[item.title];
            if (enTitle) {
              item.title = enTitle;
              // console.log('翻译为英文:', item.title);
            } else {
              // console.log('未找到对应的英文翻译');
            }
          } else {
            // console.log('标题已是英文，无需修改');
          }
        } else if (currentLanguage == 'zh-cn') {
          // console.log(currentLanguage, '中文', '当前标题:', item.title);
          // 中文环境下，检查标题是否已经是中文
          // 如果标题不包含中文字符，则需要翻译成中文
          if (!/[\u4e00-\u9fa5]/.test(item.title)) {
            // 使用正向映射表查找对应的中文标题
            const zhTitle = typeof item.title === 'string' ? titleenKeyMap[item.title] : undefined;
            if (zhTitle) {
              item.title = zhTitle;
              // console.log('翻译为中文:', item.title);
            } else {
              // console.log('未找到对应的中文翻译');
            }
          } else {
            // console.log('标题已是中文，无需修改');
          }
        }
      });
      // console.log(list, '更新后的标签列表');
    }
  }
  function generateI18nTitle(titleOrKey: string | (() => any) = t('app.route.undefined')) {
    return typeof titleOrKey === 'function'
      ? titleOrKey()
      : te(titleOrKey)
        ? t(titleOrKey)
        : titleOrKey
  }

  function switchTo(index: number) {
    menuStore.setActived(index)
    if (
      settingsStore.settings.menu.mainMenuClickMode === 'jump'
      || (settingsStore.settings.menu.mainMenuClickMode === 'smart' && menuStore.sidebarMenusHasOnlyMenu)
    ) {
      router.push(menuStore.sidebarMenusFirstDeepestPath)
    }
  }

  return {
    generateI18nTitle,
    initTabbarI18n,
    switchTo,
  }
}
